

class TikTokServerEvents {
  constructor() {
    this.pixelId = window.TikTokConfig?.pixelId || 'D0QA5RJC77U49S5Q3ACG';
    this.accessToken = window.TikTokConfig?.accessToken || '';
    this.endpoint = 'https://business-api.tiktok.com/open_api/v1.2/pixel/track/';
    this.currency = window.TikTokConfig?.currency || 'USD';
    this.enableServerEvents = window.TikTokConfig?.enableServerEvents !== false;
    this.enableClientEvents = window.TikTokConfig?.enableClientEvents !== false;
    
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.trackPageView();
  }

  setupEventListeners() {
    if (document.querySelector('[data-product-id]')) {
      this.trackViewContent();
    }

    document.addEventListener('addToCart', (event) => {
      this.trackAddToCart(event.detail);
    });

    document.addEventListener('initiateCheckout', (event) => {
      this.trackInitiateCheckout(event.detail);
    });

    document.addEventListener('purchase', (event) => {
      this.trackPurchase(event.detail);
    });

    if (window.location.pathname.includes('/search')) {
      this.trackSearch();
    }

    if (window.location.pathname.includes('/account/register')) {
      this.trackCompleteRegistration();
    }

    if (window.location.pathname.includes('/checkout')) {
      this.trackAddPaymentInfo();
    }
  }

  async hashData(data) {
    if (!data) return '';
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(data);
    const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }

  trackPageView() {
    if (!this.enableClientEvents) return;
    
    if (typeof ttq !== 'undefined') {
      ttq.page();
    }
  }

  async trackViewContent() {
    if (!this.enableClientEvents && !this.enableServerEvents) return;
    
    const productElement = document.querySelector('[data-product-id]');
    if (!productElement) return;

    const productId = productElement.dataset.productId;
    const productTitle = document.querySelector('.product__heading')?.textContent?.trim();
    const productPrice = this.extractPrice();

    if (this.enableClientEvents && typeof ttq !== 'undefined') {
      await this.identifyUser();

      ttq.track('ViewContent', {
        contents: [{
          content_id: productId,
          content_type: 'product',
          content_name: productTitle || 'Product'
        }],
        value: productPrice,
        currency: this.currency
      });
    }

      if (this.enableServerEvents) {
      this.sendServerEvent('ViewContent', {
        content_id: productId,
        content_type: 'product',
        content_name: productTitle || 'Product',
        value: productPrice,
        currency: this.currency
      });
    }
    
    console.log('🎯 TikTok Event:', 'ViewContent', {
      content_id: productId,
      content_type: 'product',
      content_name: productTitle || 'Product',
      value: productPrice,
      currency: this.currency
    });
  }

  async trackAddToCart(productData) {
    if (typeof ttq !== 'undefined') {
      await this.identifyUser();

      ttq.track('AddToCart', {
        contents: [{
          content_id: productData.id,
          content_type: 'product',
          content_name: productData.title
        }],
        value: productData.price,
        currency: this.currency
      });
    }

    this.sendServerEvent('AddToCart', {
      content_id: productData.id,
      content_type: 'product',
      content_name: productData.title,
      value: productData.price,
      currency: this.currency
    });
    
    console.log('🎯 TikTok Event:', 'AddToCart', {
      content_id: productData.id,
      content_type: 'product',
      content_name: productData.title,
      value: productData.price,
      currency: this.currency
    });
  }

  async trackInitiateCheckout() {
    const cartTotal = this.extractCartTotal();
    const cartItems = this.extractCartItems();

    if (typeof ttq !== 'undefined') {
      await this.identifyUser();

      ttq.track('InitiateCheckout', {
        contents: cartItems,
        value: cartTotal,
        currency: this.currency
      });
    }

    this.sendServerEvent('InitiateCheckout', {
      contents: cartItems,
      value: cartTotal,
      currency: this.currency
    });
    
    console.log('🎯 TikTok Event:', 'InitiateCheckout', {
      contents: cartItems,
      value: cartTotal,
      currency: this.currency
    });
  }

  async trackPurchase(orderData) {
    if (typeof ttq !== 'undefined') {
      await this.identifyUser();

      ttq.track('Purchase', {
        contents: orderData.items,
        value: orderData.total,
        currency: this.currency
      });
    }

    this.sendServerEvent('Purchase', {
      contents: orderData.items,
      value: orderData.total,
      currency: this.currency
    });
    
    console.log('🎯 TikTok Event:', 'Purchase', {
      contents: orderData.items,
      value: orderData.total,
      currency: this.currency
    });
  }

  async trackSearch() {
    const searchQuery = new URLSearchParams(window.location.search).get('q');
    if (!searchQuery) return;

    if (typeof ttq !== 'undefined') {
      await this.identifyUser();

      ttq.track('Search', {
        search_string: searchQuery,
        currency: this.currency
      });
    }

    this.sendServerEvent('Search', {
      search_string: searchQuery,
      currency: this.currency
    });
    
    console.log('🎯 TikTok Event:', 'Search', {
      search_string: searchQuery,
      currency: this.currency
    });
  }

  async trackCompleteRegistration() {
    if (typeof ttq !== 'undefined') {
      await this.identifyUser();

      ttq.track('CompleteRegistration', {
        currency: this.currency
      });
    }

    this.sendServerEvent('CompleteRegistration', {
      currency: this.currency
    });
  }

  async trackAddPaymentInfo() {
    if (typeof ttq !== 'undefined') {
      await this.identifyUser();

      ttq.track('AddPaymentInfo', {
        currency: this.currency
      });
    }

    this.sendServerEvent('AddPaymentInfo', {
      currency: this.currency
    });
  }

  async identifyUser() {
    const customerEmail = this.getCustomerEmail();
    const customerPhone = this.getCustomerPhone();
    const customerId = this.getCustomerId();

    if (customerEmail || customerPhone || customerId) {
      const hashedEmail = customerEmail ? await this.hashData(customerEmail) : '';
      const hashedPhone = customerPhone ? await this.hashData(customerPhone) : '';
      const hashedId = customerId ? await this.hashData(customerId) : '';

      if (typeof ttq !== 'undefined') {
        ttq.identify({
          email: hashedEmail,
          phone_number: hashedPhone,
          external_id: hashedId
        });
      }
    }
  }

  extractPrice() {
    const priceElement = document.querySelector('.price__regular .price-item--regular, .price__sale .price-item--sale');
    if (priceElement) {
      const priceText = priceElement.textContent.replace(/[^0-9.,]/g, '');
      return parseFloat(priceText.replace(',', '.'));
    }
    return 0;
  }

  extractCartTotal() {
    const totalElement = document.querySelector('.cart__totals .totals__subtotal-value, .cart__total');
    if (totalElement) {
      const totalText = totalElement.textContent.replace(/[^0-9.,]/g, '');
      return parseFloat(totalText.replace(',', '.'));
    }
    return 0;
  }

  extractCartItems() {
    const cartItems = [];
    const itemElements = document.querySelectorAll('.cart-item');

    itemElements.forEach(item => {
      const itemId = item.querySelector('[data-product-id]')?.dataset?.productId;
      const itemTitle = item.querySelector('.cart-item__name')?.textContent?.trim();
      const itemPrice = item.querySelector('.price')?.textContent?.replace(/[^0-9.,]/g, '');

      if (itemId && itemTitle) {
        cartItems.push({
          content_id: itemId,
          content_type: 'product',
          content_name: itemTitle,
          value: parseFloat(itemPrice?.replace(',', '.') || '0')
        });
      }
    });

    return cartItems;
  }

  getCustomerEmail() {
    return localStorage.getItem('customer_email') || 
           this.getCookie('customer_email') || 
           document.querySelector('[name="customer[email]"]')?.value;
  }

  getCustomerPhone() {
    return localStorage.getItem('customer_phone') || 
           this.getCookie('customer_phone') || 
           document.querySelector('[name="customer[phone]"]')?.value;
  }

  getCustomerId() {
    return localStorage.getItem('customer_id') || 
           this.getCookie('customer_id') || 
           document.querySelector('[data-customer-id]')?.dataset?.customerId;
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  async sendServerEvent(eventName, eventData) {
    if (!this.accessToken) {
      console.log('TikTok Access Token no configurado');
      return;
    }

    try {
      const eventPayload = {
        pixel_code: this.pixelId,
        event: eventName,
        timestamp: new Date().toISOString(),
        event_id: this.generateEventId(),
        properties: {
          currency: this.currency,
          value: eventData.value || 0,
          query: {
            external_id: await this.hashData(this.getCustomerEmail() || '')
          },
          ...eventData
        }
      };

      const response = await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'Access-Token': this.accessToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(eventPayload)
      });

      if (response.ok) {
        console.log(`Evento ${eventName} enviado exitosamente al servidor de TikTok`);
      } else {
        console.error(`Error al enviar evento ${eventName}:`, response.statusText);
      }
    } catch (error) {
      console.error(`Error al enviar evento ${eventName}:`, error);
    }
  }

  generateEventId() {
    return 'evt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  trackCustomEvent(eventName, eventData) {
    if (this.enableClientEvents && typeof ttq !== 'undefined') {
      ttq.track(eventName, eventData);
    }

    if (this.enableServerEvents) {
      this.sendServerEvent(eventName, eventData);
    }
  }

  updateCartInfo() {
    console.log('Información del carrito actualizada');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  try {
    window.tiktokServerEvents = new TikTokServerEvents();
  } catch (error) {
    console.error('❌ Error TikTok:', error);
  }
});

if (document.readyState !== 'loading') {
  try {
    window.tiktokServerEvents = new TikTokServerEvents();
  } catch (error) {
    console.error('❌ Error TikTok:', error);
  }
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = TikTokServerEvents;
}
